<template>
  <div>
    <Congratulations />
    <section class="section is-body">
      <div class="container has-text-centered mb-3">
        <hr class="is-inline">
        <h3 class="is-recognize title is-size-6 is-uppercase">
          Recognize Your Accomplishment
        </h3>
      </div>
      <div class="container columns is-centered has-text-centered is-mobile is-multiline">
        <div class="column is-4-desktop is-6-touch">
          <router-link :to="`${$router.currentRoute.params.slug}/update-info`">
            <div class="card-image">
              <figure class="image is-3by1">
                <img src="/images/update.png">
              </figure>
            </div>
            <span class="title is-size-4">Update Your Info</span>
          </router-link>
          <p class="card-content">
            Confirm your most up-to-date information to be published.
          </p>
        </div>
        <div class="column is-4-desktop is-6-touch">
          <router-link :to="`${$router.currentRoute.params.slug}/advertise`">
            <div class="card-image">
              <figure class="image is-3by1">
                <img src="/images/advertise.png">
              </figure>
            </div>
            <span class="title is-size-4">Advertise</span>
          </router-link>
          <p class="card-content">
            Meet with a sales associate to discuss the optimal advertising package for you.
          </p>
        </div>
        <CallToAction v-for="cta in ctas" :key="cta.title" :cta="cta" />
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      ctas(state) {
        return state[this.$route.params.slug].ctas
      },
    }),
  },
  components: {
    CallToAction: () => import('@/components/CallToAction.vue'),
    Congratulations: () => import('@/components/Congratulations.vue'),
  },
};
</script>
